package anjuros.development.util

import anjuros.development.modules.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val MainHeaderContactStyle = CssStyle {

    base {
        Modifier
            .scale(1.0)
            .transition(Transition.of(property = "scale", duration = 200.ms))
    }
    hover {
        Modifier
            .scale(1.2)
    }
}

val NavigationItemStyle = CssStyle {
    cssRule(" > #sectionUnderline"){
        Modifier .opacity(0.0)
            .transition(Transition.of(property = "opacity", duration = 200.ms))
    }
    cssRule(":hover > #sectionUnderline"){
        Modifier .opacity(1.0)
    }
}

val MenuWidthStyle = CssStyle {
    base { Modifier.width(50.percent) }
    Breakpoint.MD {  Modifier.width(25.percent) }
    Breakpoint.LG {Modifier.width(25.percent) }
    Breakpoint.XL { Modifier.width(25.percent)}
}

val ContactMeDetailsFontStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD { Modifier.fontSize(20.px) }
    Breakpoint.LG { Modifier.fontSize(24.px) }
    Breakpoint.XL { Modifier.fontSize(24.px)}
}

val ContactButtonStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 0.px)
            .transition(Transition.of("padding", 200.ms))
    }
    hover {
        Modifier
            .padding(leftRight = 10.px)
            .width(Width.FitContent)
    }
}

val RoomColumnWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(40.percent)}
}

val SmallSectionWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(60.percent)}
}

val ReviewArrowStyle = CssStyle {
    base {
        Modifier
            .color(Theme.Gray.rgb)
            .transition(Transition.of("color", 200.ms))
    }
    hover {
        Modifier
            .color(Theme.Primary.rgb)
    }
}

val ReviewSingleCardWidthStyle = CssStyle {

    base { Modifier.width(300.px) }
    Breakpoint.MD { Modifier.width(300.px) }
    Breakpoint.LG { Modifier.width(350.px) }
    Breakpoint.XL { Modifier.width(350.px) }
}
val ReviewCardMaxWidthStyle = CssStyle {

    base { Modifier.maxWidth(350.px) }
    Breakpoint.MD { Modifier.maxWidth(625.px) }
    Breakpoint.LG { Modifier.maxWidth(1100.px) }
    Breakpoint.XL { Modifier.maxWidth(1100.px) }
}
val RoomCardSizeStyle = CssStyle {

    base { Modifier.height(380.px)
        .fillMaxWidth() }
    Breakpoint.MD { Modifier.height(400.px)
        .fillMaxWidth() }
    Breakpoint.LG { Modifier.height(470.px)
        .fillMaxWidth() }
    Breakpoint.XL { Modifier.height(470.px)
        .fillMaxWidth() }
}
val RoomImageStyle = CssStyle {

    base { Modifier.height(240.px)
        .fillMaxWidth()}
    Breakpoint.MD { Modifier.height(262.px)
        .fillMaxWidth() }
    Breakpoint.LG { Modifier.height(350.px)
        .fillMaxWidth() }
    Breakpoint.XL { Modifier.height(350.px)
        .fillMaxWidth() }
}

val RoomZoomImageStyle = CssStyle {

    base { Modifier.fillMaxWidth()
        .height(250.px)}
    Breakpoint.MD { Modifier.fillMaxWidth()
        .height(250.px) }
    Breakpoint.LG { Modifier.size(900.px, 600.px) }
    Breakpoint.XL { Modifier.size(900.px, 600.px) }
}


val RoomCardStyle = CssStyle {
    base { Modifier.height(380.px)
        .fillMaxWidth(80.percent) }
    Breakpoint.MD { Modifier.height(400.px)
        .margin(leftRight = 30.px)
        .fillMaxWidth(80.percent) }
    Breakpoint.LG { Modifier.height(470.px)
        .margin(leftRight = 30.px)
        .fillMaxWidth(80.percent) }
    Breakpoint.XL { Modifier.height(470.px)
        .fillMaxWidth(80.percent)
        .margin(leftRight = 30.px)}
    cssRule("> #roomBorder> #roomInformation> #roomTitle"){
        Modifier
            .color(Theme.DarkGrey.rgb)
    }
    cssRule(":hover>  #roomBorder> #roomInformation> #roomTitle"){
        Modifier
            .color(Colors.White)
    }
    cssRule(" > #roomBorder") {
        Modifier.border(
            width = 1.px,
            color = Colors.DarkGray,
            style = LineStyle.Solid,
        )
            .borderRadius(30.px)
            .boxShadow(
                2.px, 2.px, 10.0.px, 1.0.px, color = Colors.DarkGray, false
            )
            .backgroundColor(Colors.Transparent)
            .transition(
                Transition.of(property = "border", duration = 200.ms),
                Transition.of(property = "boxShadow", duration = 200.ms)
            )
    }
    cssRule(":hover >#roomBorder") {
        Modifier.border(
            width = 1.px,
            color = Theme.Primary.rgb,
            style = LineStyle.Solid,
        )
            .borderRadius(30.px)
            .boxShadow(
                4.px, 4.px, 15.0.px, 2.0.px, color = Theme.Primary.rgb, false
            )
            .borderRadius(30.px)
            .backgroundColor(Theme.Primary.rgb)
            .transition(
                Transition.of(property = "border", duration = 200.ms),
                Transition.of(property = "boxShadow", duration = 200.ms)
            )
    }
}

val NearbyRotationStyle = CssStyle {
    base {
        Modifier
            .scale(1.0)
            .transition(Transition.of("scale", 200.ms))
    }
    hover {
        Modifier
            .scale(1.05)
    }
}

val FaqHeaderStyle = CssStyle {
    base { Modifier.fontSize(22.px) }
    Breakpoint.MD { Modifier.fontSize(22.px) }
    Breakpoint.LG { Modifier.fontSize(24.px) }
    Breakpoint.XL { Modifier.fontSize(24.px)}
}

val FaqSubheaderStyle = CssStyle {
    base { Modifier.fontSize(16.px) }
    Breakpoint.MD { Modifier.fontSize(18.px) }
    Breakpoint.LG { Modifier.fontSize(18.px) }
    Breakpoint.XL { Modifier.fontSize(18.px)}
}

val FaqWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(80.percent)}
}

val NavigationFooterItemStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(Theme.Primary.rgb)
    }
}
val FooterMarginStyle = CssStyle {
    base { Modifier.margin(topBottom = 20.px) }
    Breakpoint.MD { Modifier.margin(topBottom = 0.px) }
    Breakpoint.LG { Modifier.margin(topBottom = 0.px) }
    Breakpoint.XL { Modifier.margin(topBottom = 0.px)}
}